/**
 * Rutas de la aplicación, centralizadas.
 *
 * Un único lugar para los paths: lo consume el modelo de navegación
 * (`navConfig.ts`) y la tabla de rutas (`routes/AppRoutes.tsx`), de modo que el
 * enlace del menú y la ruta registrada nunca se desincronicen. Las pantallas de
 * dominio llegan en features posteriores (#45+); por ahora cada path se sirve
 * con un placeholder.
 */
export const ROUTES = {
  dashboard: "/",
  // Órdenes
  ordersNew: "/ordenes/nueva",
  ordersEdit: "/ordenes/:orderId/editar",
  ordersPending: "/ordenes/pendientes",
  ordersInProcess: "/ordenes/en-proceso",
  ordersDelivered: "/ordenes/entregadas",
  ordersCancelled: "/ordenes/anuladas",
  ordersSearch: "/ordenes/buscar",
  // Operación / Horarios
  schedule: "/horario",
  laserSchedule: "/horario-laser",
  // Talonarios
  talonarios: "/talonarios",
  talonarioDetail: "/talonarios/detalle/:worker",
  talonarioHistory: "/talonarios/historial",
  talonarioMismatches: "/talonarios/descuadres",
  talonarioHistorical: "/talonarios/historico/:worker/:start/:end",
  // Equipo
  users: "/equipo/usuarios",
  // Admin
  sedes: "/admin/sedes",
  atendidos: "/admin/atendidos",
  roles: "/admin/roles",
  settings: "/admin/configuracion",
  cotizadorPrecios: "/admin/precios-cotizador",
  // Análisis
  advancedStats: "/analisis/estadisticas",
  userActivity: "/analisis/actividad",
  // Inventario
  inventario: "/inventario",
  inventarioAdmin: "/inventario/activar-por-sede",
  // Herramientas
  cotizador: "/herramientas/cotizador",
  cutlist: "/herramientas/optimizador",
  pedidosLaminas: "/herramientas/pedidos-laminas",
  pedidosLaminasHistorial: "/herramientas/pedidos-laminas/historial",
  pedidosLaminasEdit: "/herramientas/pedidos-laminas/:pedidoId/editar",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

/** Ruta concreta de edición de una orden (sustituye el `:orderId` del patrón). */
export function orderEditPath(orderId: number): string {
  return `/ordenes/${orderId}/editar`;
}

/** Ruta concreta de edición de un pedido de láminas (sustituye `:pedidoId`). */
export function pedidoEditPath(pedidoId: number): string {
  return `/herramientas/pedidos-laminas/${pedidoId}/editar`;
}

/** Ruta concreta del detalle de talonario de un trabajador. */
export function talonarioDetailPath(worker: string): string {
  return `/talonarios/detalle/${encodeURIComponent(worker)}`;
}

/** Ruta concreta del histórico de un rango de talonario (solo lectura). */
export function talonarioHistoricalPath(
  worker: string,
  start: number,
  end: number,
): string {
  return `/talonarios/historico/${encodeURIComponent(worker)}/${start}/${end}`;
}
